var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DocsSharedExternally } from '@web/components/PerformanceReview/Employee/Sections/PolicyCompliance/DocsSharedExternally';
import { DocsSharedExternallyByLabel } from '@web/components/PerformanceReview/Employee/Sections/PolicyCompliance/DocsSharedExternallyByLabel';
import { SharedFiles } from '@web/components/PerformanceReview/Employee/Sections/PolicyCompliance/SharedFiles';
export var PolicyComplianceSection = function (_a) {
    var userId = _a.userId, orgUnitId = _a.orgUnitId, dateFrom = _a.dateFrom, dateTo = _a.dateTo, _b = _a.isSecondaryDiffHidden, isSecondaryDiffHidden = _b === void 0 ? false : _b;
    return (_jsxs("div", __assign({ className: "flex flex-col gap-20 mt-5" }, { children: [_jsx(DocsSharedExternallyByLabel, { userId: userId, orgUnitId: orgUnitId, dateFrom: dateFrom, dateTo: dateTo, isSecondaryDiffHidden: isSecondaryDiffHidden }), _jsx(DocsSharedExternally, { userId: userId, orgUnitId: orgUnitId, dateFrom: dateFrom, dateTo: dateTo }), _jsx(SharedFiles, { userId: userId, orgUnitId: orgUnitId, dateFrom: dateFrom, dateTo: dateTo })] })));
};
